import { useEffect, useMemo, useState } from "react"
import Spinner from "../../components/Spinner";
import { Button, FormControl, IconButton, MenuItem, Pagination, PaginationItem, Select, Stack, TextField, Tooltip } from "@mui/material";
import { IoAdd, IoAddCircleSharp, IoAddSharp, IoCash, IoChevronDown, IoCloseSharp, IoLockClosed, IoLockOpen, IoSave, IoSearch, IoTime } from "react-icons/io5";
import Swal from 'sweetalert2'
import { CalcularExpiracion, currencyFormat, generateBackgroundColor, message, setUnixToTimeFormat } from "../../utils/Funciones.js";
import { MdAlternateEmail, MdDelete, MdEdit, MdSupervisorAccount, MdVerifiedUser } from "react-icons/md";
import { FaChessKing, FaClipboard, FaCoins, FaDollarSign, FaPencilAlt, FaPlus, FaPlusCircle, FaTrashAlt, FaUser, FaUserTie, FaWallet } from 'react-icons/fa';
import Wrapper from "./Wrapper";
import { FcPlus } from "react-icons/fc";
import { Link, useNavigate } from "react-router-dom";
import UpdateUser from "./UpdateUser";
import { BsInfo } from "react-icons/bs";
import debounce from 'lodash.debounce';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import SpinnerData from "../../components/SpinnerData";
import Spinner2 from "../../components/Spinner2";
import { useDispatch, useSelector } from "react-redux";
import { SET_TO_DEFAULT_RESPONSE, addCash, createClient, del, delClient, getByPage, getClientsByPage, contadorClients as getContador, lock, updateVip } from "../../store/features/slices/userSlice";
import { uriSerialized } from "../../utils/uriSerialized";
import { FaBusinessTime, FaLock, FaLockOpen, FaRegCalendarPlus, FaRegUser, FaUserCheck, FaUserClock, FaUserLock, FaUserTag, FaUsersGear } from "react-icons/fa6";
import { Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import Modal from "../../components/modal/Modal";
import CopyToClipboard from "react-copy-to-clipboard";
import Socket, { authSocket, logoutSocket } from '../../utils/Socket';
import SpinnerButtom from "../../components/SpinnerButtom";
import { RiVipCrownFill } from "react-icons/ri";
import CardVip from "../../components/CardVip";
import { CURRENCY } from "../../utils/Constants";
import CountUp from 'react-countup';
import { MuiTelInput } from "mui-tel-input";
const moment = require("moment");
require("moment/locale/es");

const Clients = ({ }) => {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const [currentPage, setCurrentPage] = useState(1);
   const [curTime, SetCurTime] = useState(null)
   const [searchTerm, setSearchTerm] = useState('');
   const [eliminandoId, setEliminandoId] = useState(null);
   const [limit, setLimit] = useState(30);
   const [usersFilter, setUsersFilter] = useState('')
   const [state, setState] = useState({
      open: false,
      name: '',
      phonenumber: '',
      countrycode: ''

   });

   const {
      clientsByPage,
      isMutation,
      contadorClients,
      totalFilterClients,
      totalClients,
      totalPagesClients,
      configuration,
      admin
   } = useSelector((state) => state.userReducer);

   useEffect(() => {
      const interval = setInterval(async () => {
         SetCurTime(new Date().toLocaleString());
      }, 1000);
      return () => clearInterval(interval);
   }, [])

   useEffect(() => {
      if (isMutation.successDeleted) {
         message(isMutation.message, 'success', 5)
         const queryOptions = {
            page: currentPage,
            limit: limit,
            search: searchTerm.trim(),
         }
         const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
         dispatch(getClientsByPage(query))
         dispatch(getContador())
         dispatch(SET_TO_DEFAULT_RESPONSE())
      }
   }, [isMutation.successDeleted, dispatch]);

   useEffect(() => {
      if (isMutation.success) {
         message(isMutation.message, 'success', 5)
         setState({ ...state, name: "", phonenumber: "", countrycode: "" })
         dispatch(getContador())
         dispatch(SET_TO_DEFAULT_RESPONSE())
      }
   }, [isMutation.success, dispatch]);

   useEffect(() => {
      const queryOptions = {
         page: currentPage,
         limit: limit,
         search: searchTerm.trim(),
      }
      const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
      dispatch(getClientsByPage(query))
   }, [dispatch, searchTerm, currentPage, limit]);

   useEffect(() => {
      dispatch(getContador())
   }, []);

   const onSubmitNewClient = (e) => {
      e.preventDefault()
      dispatch(createClient(state))
   }

   const deleteClient = id => {
      alertaConfirmar('eliminar cliente', 'Estas seguro que quieres eliminar este cliente?', 'question', (res_alert) => {
         if (res_alert === true) {
            setEliminandoId(id);
            setTimeout(() => {
               dispatch(delClient(id));
               setEliminandoId(null);
            }, 700);
         }
      })
   }

   const changeHandleSearch = (event) => {
      setSearchTerm(event.target.value)
      setCurrentPage(1);
   };

   const debouncedChangeHandler = useMemo(() => debounce(changeHandleSearch, 500), []);

   const handleChange = (e, p) => {
      setCurrentPage(p);
   };

   const HandleChangeFilterClients = async (state) => {
      setSearchTerm(state)
      setUsersFilter(state)
      setCurrentPage(1);
   }

   const onChangeSearchTermClear = e => {
      setSearchTerm("");
      HandleChangeFilterClients("")
      document.getElementById("search").value = "";
   };

   const alertaConfirmar = (titulo, texto, icon, callback) => {
      Swal.fire({
         title: titulo,
         html: texto,
         icon: icon,
         showCancelButton: true,
         confirmButtonText: 'Si',
         denyButtonText: 'No',
         cancelButtonText: 'Cancelar',
         confirmButtonColor: '#2C3E50',
         cancelButtonColor: '#CB4335'
      }).then((result) => {
         if (result.isConfirmed) {
            callback(result.isConfirmed)
         }
      })
   }

   const onCopy = (text) => {
      message(text, 'success', 2)
   }

   return (
      <Wrapper>
         <div className="fixed ml-7 md:ml-0 pl-3 md:pl-3 lg:pl-3 h-8 top-2 md:top-11 z-30 flex items-center w-full md:w-8/12 text-brand-900 dark:text-brand-100 text-[1.2rem] md:text-[1.8rem] lg:text-[2rem] font-semibold">
            Clientes
            <div class="flex items-center justify-center px-3 ml-3 text-xl font-medium bg-brand-300 dark:bg-brand-800 text-brand-800 dark:text-brand-200 rounded-full">
               {!contadorClients.loading && contadorClients.total}
            </div>
         </div>
         {/* HEADER PAGES */}
         <div className="fixed mt-8 p-4 flex items-center text-brand-900 dark:text-brand-100 uppercase w-[calc(100%-1.50rem)] md:w-[calc(100%-1.50rem)] lg:w-[calc(100%-26.50rem)] font-semibold bg-white dark:bg-brand-900 backdrop-blur-lg z-20 rounded-b-xl">
            <div className="!w-9/12">
               <InputGroup className="w-full md:w-[450px] md:max-w-[450px]">
                  <InputLeftElement pointerEvents="none" className="!mt-[14px] !ml-2">
                     <FiSearch size={24} className="text-brand-900 dark:text-brand-100" />
                  </InputLeftElement>
                  <Input size='lg' autoFocus id="search" variant='flushed' onChange={debouncedChangeHandler} type="text" placeholder={`Buscar clientes...`} className="flex w-full md:w-[450px] md:max-w-[450px] !h-14 !pl-10 !items-center !justify-center !border-2 rounded-xl !bg-brand-200 
            dark:!bg-brand-950 !text-sm focus:!ring-lightPrimary dark:focus:!ring-darkPrimary focus:!border-lightPrimary dark:focus:!border-darkPrimary 
            !outline-none !border-brand-300 dark:!border-brand-800 !text-brand-900 dark:!text-white !relative !placeholder-brand-500" />
                  <InputRightElement className="!mt-[8px] !mr-1">
                     <IconButton onClick={onChangeSearchTermClear} className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-brand-600 dark:text-brand-300`}>
                        <IoCloseSharp size={20} className="text-brand-900 dark:text-brand-100" />
                     </IconButton>
                  </InputRightElement>
               </InputGroup>
            </div>
            <div className="!w-3/12 flex items-center justify-end">
               <div className="flex items-center justify-end">
                  <Tooltip title="registrar cliente" arrow={true}>
                     <Button onClick={() => setState({ ...state, open: !state.open })} type="button" className="!bg-green-500" sx={{ maxWidth: 35, minWidth: 35, maxHeight: 35, minHeight: 35 }}>
                        <FaPlus size={45} className="!text-white" />
                     </Button>
                  </Tooltip>
               </div>
            </div>
         </div>

         <div className="w-[calc(100%-1.50rem)] md:w-[calc(100%-1.50rem)] lg:w-[calc(100%-26.50rem)] mb-0 mt-[102px] pb-3 pt-5 md:pt-5 lg:pt-10 fixed z-20 bg-white/10 dark:bg-[#00000023] backdrop-blur-lg flex flex-col md:flex-col lg:flex-row items-center">
            <div className="w-full flex items-center justify-center md:justify-end text-brand-200 mb-6 md:mb-6 lg:mb-0">
               {
                  !isMutation.loading ?
                     <>
                        <div className="hidden md:block">
                           <Stack spacing={2}>
                              <Pagination
                                 count={Math.ceil(!isMutation.loading && Number(totalFilterClients) / limit)}
                                 page={currentPage}
                                 onChange={handleChange}
                                 variant="text"
                                 color="primary"
                                 shape="rounded"
                                 size="large"
                                 renderItem={(item) => (
                                    <PaginationItem
                                       slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                       {...item}
                                    />
                                 )}
                                 className="bg-brand-200 dark:bg-brand-950"
                              />
                           </Stack>
                        </div>

                        <div className="block md:hidden">
                           <Stack spacing={2}>
                              <Pagination
                                 count={Math.ceil(!isMutation.loading && Number(totalFilterClients) / limit)}
                                 page={currentPage}
                                 onChange={handleChange}
                                 variant="text"
                                 color="primary"
                                 shape="rounded"
                                 size="small"
                                 renderItem={(item) => (
                                    <PaginationItem
                                       slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                       {...item}
                                    />
                                 )}
                                 className="bg-brand-200 dark:bg-brand-950"
                              />
                           </Stack>
                        </div>
                     </> : <Spinner />
               }
            </div>
         </div>

         <Modal
            open={state.open}
            onClose={() => setState({ ...state, name: "", phonenumber: "", countrycode: "", open: false })}
            headerTitle="Registrar cliente"
            size="sm"
         >
            <div className="w-full gap-4">
               <form className="w-full flex flex-wrap gap-3" onSubmit={onSubmitNewClient}>
                  <div className="w-full">
                     <label for="first_name" class="block mb-2 text-sm font-medium text-brand-900 dark:text-white">Nombre</label>
                     <input autoFocus name="name" className="custom-style-input"
                        autoComplete="off"
                        required
                        type="text"
                        value={state.name}
                        onChange={(e) => setState({ ...state, name: e.target.value })}
                     />
                  </div>
                  <div className="w-full">
                     <label for="first_name" class="block mb-2 text-sm font-medium text-brand-900 dark:text-white">Numero celular</label>
                     <MuiTelInput
                        inputProps={{ className: "text-brand-900 dark:text-brand-200" }}
                        value={state.phonenumber}
                        defaultCountry={'PE'}
                        onChange={(newValue, info) => setState({ ...state, countrycode: info.countryCode, phonenumber: newValue })}
                        className="custom-style-input"
                     />
                  </div>
                  <div className="flex m-auto w-full">
                     <Button
                        type="submit"
                        disabled={isMutation.loading ? true : false}
                        style={{ width: '100%', height: 65, marginLeft: 'auto', marginRight: 'auto' }}
                        size='large' variant="contained"
                     >
                        {isMutation.loading ? <Spinner /> : <IoSave size={24} className="mr-2" />}
                        {isMutation.loading ? 'Guardando...' : 'Registrar CLIENTE'}
                     </Button>
                  </div>
               </form>
            </div>
         </Modal>

         <div className="relative w-full">
            {
               !isMutation.loading ? clientsByPage.length > 0 ?
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-9 mt-[190px] md:mt-[205px] lg:mt-[210px]">
                     {clientsByPage.map((client) => {
                        const isDeleting = eliminandoId === client._id;
                        return (
                           <div className={`p-4 relative w-full shadow-xl shadow-neutral-200 dark:shadow-none cursor-pointer bg-white dark:bg-brand-900 text-brand-900 dark:text-brand-200 flex flex-wrap rounded-2xl 
                           transition-[opacity,transform,filter] duration-700 ease-in-out 
                           ${isDeleting ? 'opacity-0 blur-2xl' : 'opacity-100 blur-none'}`} key={client._id}>
                              <div className="w-full flex flex-wrap items-center">
                                 <div className="w-[55px] h-[55px] overflow-hidden flex items-center justify-center">
                                    <img
                                       className="w-full h-full object-cover rounded-full"
                                       alt={'No image'}
                                       src={`/images/flags/1x1/${client.countrycode}.svg`}
                                    />
                                 </div>
                                 <div className="w-[calc(100%-90px)] grid px-4 items-center">
                                    <div className="font-semibold text-lg">
                                       {client.name}
                                    </div>
                                    <div className="flex items-center gap-2 text-base font-normal">
                                       <span className="truncate">{client.phonenumber}</span>
                                       <Tooltip title="Copiar" arrow>
                                          <div>
                                             <CopyToClipboard text={client.phonenumber} onCopy={() => onCopy('número copiado')}>
                                                <FaClipboard
                                                   size={18}
                                                   className="text-brand-800 dark:text-brand-300 cursor-pointer hover:scale-110 transition"
                                                />
                                             </CopyToClipboard>
                                          </div>
                                       </Tooltip>
                                    </div>
                                    <div className="text-sm font-light text-brand-700 dark:text-brand-400">
                                       {setUnixToTimeFormat('created_at', client.created_at)}
                                    </div>
                                 </div>
                                 <div className="w-[35px] h-[75px] overflow-hidden flex items-center justify-center">
                                    <Tooltip title="eliminar" arrow={true}>
                                       <Button onClick={() => deleteClient(client._id)} variant="contained" sx={{ maxWidth: 35, minWidth: 35, maxHeight: 35, minHeight: 35 }} className="rounded-xl !bg-red-500 !px-2 !py-2 !text-base font-medium !text-white transition !duration-200 hover:!bg-red-600 active:!bg-red-700 dark:!bg-red-400 dark:!text-white dark:hover:!bg-red-300 dark:active:!bg-red-200">
                                          <FaTrashAlt className="w-5 h-5 text-white" />
                                       </Button>
                                    </Tooltip>
                                 </div>
                              </div>
                           </div>
                        )
                     })}
                  </div> : <div className="alert-danger font-semibold mt-[190px] md:mt-[205px] lg:mt-[210px]">Sin resultados en la búsqueda! o no existen clientes registradas</div> : <div className="mt-[190px] md:mt-[205px] lg:mt-[210px]"><SpinnerData>Cargando clientes, por favor espere...</SpinnerData></div>}
         </div>
      </Wrapper >
   )
}
export default Clients;